import { render } from "./PCP_REPOSITION_RETAILER.vue?vue&type=template&id=a616560a"
import script from "./PCP_REPOSITION_RETAILER.vue?vue&type=script&lang=ts"
export * from "./PCP_REPOSITION_RETAILER.vue?vue&type=script&lang=ts"
script.render = render

export default script